<template>
    <section class="accesos-home container row-start ais" v-if="!!getDestacados(position) && getDestacados(position).length != 0">

        <h2 class="big-bold-title -blue -center" v-if="!withouttitle">Destacamos</h2>
        <span v-else></span>

        <article class="column-center"  :style="'background:url('+destacado.image+') center/cover no-repeat'" :hashref="!!destacado.href" v-for="destacado in getDestacados(position).slice(0,3)" >
            <h2>{{destacado.name}}</h2>
            <p>{{destacado.subtitle}}</p>
            <button v-if="!!destacado.button_text && destacado.button_active == 1" class="btn -skull -white -azul">{{destacado.button_text}}</button>
            <a v-if="!!destacado.href" :href="destacado.href" :target="(destacado.target) ? '_blank' : '_self'" class="enlace-cover"></a>
            <span v-else class="enlace-cover"></span>

            

        </article>

    </section>

</template>

<script>

    import { mapGetters } from 'vuex'

    export default {
        name: 'destacados',
        props: ['position','withouttitle'],
        computed: {
            ...mapGetters({
                getDestacados: 'getDestacados'
            })
        }
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/parts/destacados.vue